module.exports = __webpack_public_path__ + "static/media/34.b0ec9873.png";